var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#E22C32"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#C71706",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.777 29.3288C29.589 31.02 30.6959 32.6051 32.0977 34.0069C33.4996 35.4088 35.0847 36.5157 36.7759 37.3277C36.9214 37.3975 36.9941 37.4325 37.0861 37.4593C37.4132 37.5546 37.8149 37.4862 38.0919 37.2878C38.1698 37.232 38.2365 37.1653 38.3699 37.0319C38.7777 36.6241 38.9817 36.4201 39.1867 36.2868C39.9601 35.784 40.9571 35.784 41.7305 36.2868C41.9356 36.4201 42.1395 36.6241 42.5474 37.0319L42.7747 37.2593C43.3947 37.8793 43.7047 38.1893 43.8731 38.5223C44.2081 39.1844 44.2081 39.9664 43.8731 40.6285C43.7047 40.9615 43.3947 41.2715 42.7747 41.8915L42.5908 42.0754C41.9729 42.6933 41.664 43.0023 41.2439 43.2382C40.7778 43.5 40.0539 43.6883 39.5194 43.6867C39.0376 43.6853 38.7083 43.5918 38.0498 43.4049C34.5108 42.4004 31.1714 40.5052 28.3854 37.7192C25.5995 34.9333 23.7042 31.5938 22.6998 28.0549C22.5129 27.3964 22.4194 27.0671 22.418 26.5853C22.4164 26.0507 22.6046 25.3268 22.8665 24.8607C23.1024 24.4407 23.4114 24.1318 24.0293 23.5139L24.2132 23.33C24.8332 22.7099 25.1432 22.3999 25.4761 22.2315C26.1383 21.8966 26.9203 21.8966 27.5824 22.2315C27.9154 22.3999 28.2254 22.7099 28.8454 23.33L29.0727 23.5573C29.4806 23.9652 29.6846 24.1691 29.8179 24.3742C30.3207 25.1476 30.3207 26.1446 29.8179 26.9179C29.6846 27.123 29.4806 27.327 29.0727 27.7348C28.9394 27.8682 28.8727 27.9349 28.8169 28.0128C28.6185 28.2898 28.55 28.6915 28.6454 29.0185C28.6722 29.1106 28.7071 29.1833 28.777 29.3288Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.160334ab0fe96886d90da6d05ae7f964.svg";
export { ForwardRef as ReactComponent };